import type React from 'react';

import { withStyles } from '@material-ui/core';
import type { FormControlLabelProps } from '@material-ui/core/FormControlLabel';

import { FormControlLabel } from '../FormControlLabel';
import { labelStyle } from '../Label';

export interface SelectionControlProps extends Partial<FormControlLabelProps> {
  control: React.ReactElement<any>;
  title?: string;
  ellipsis?: boolean;
}

interface SelectionProps {
  ellipsis?: boolean;
}

const LabeledSelectionControlStyled = withStyles({
  root: {
    margin: 0,
  },
  label: {
    ...labelStyle,
    marginLeft: '10px',
    textOverflow: (props: SelectionProps) => (props.ellipsis ? 'ellipsis' : undefined),
    overflow: (props: SelectionProps) => (props.ellipsis ? 'hidden' : undefined),
    textWrap: (props: SelectionProps) => (props.ellipsis ? 'nowrap' : undefined),
    whiteSpace: (props: SelectionProps) => (props.ellipsis ? 'nowrap' : undefined),
  },
})(FormControlLabel);

const SelectionControlStyled = withStyles({
  root: {
    margin: 0,
  },
  label: {
    ...labelStyle,
    textOverflow: (props: SelectionProps) => (props.ellipsis ? 'ellipsis' : undefined),
    overflow: (props: SelectionProps) => (props.ellipsis ? 'hidden' : undefined),
    textWrap: (props: SelectionProps) => (props.ellipsis ? 'nowrap' : undefined),
    whiteSpace: (props: SelectionProps) => (props.ellipsis ? 'nowrap' : undefined),
  },
})(FormControlLabel);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const SelectionControl = (props: SelectionControlProps) => {
  const { label, title, ellipsis, ...otherProps } = props;

  // avoids recreating the component what could cause a performance issue
  const SelectionControlComponent = label ? LabeledSelectionControlStyled : SelectionControlStyled;

  return <SelectionControlComponent ellipsis={ellipsis} title={title} label={label} {...otherProps} />;
};
